import { render, staticRenderFns } from "./BkashPromotionBanner.vue?vue&type=template&id=033bec90&scoped=true"
import script from "./BkashPromotionBanner.vue?vue&type=script&lang=js"
export * from "./BkashPromotionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033bec90",
  null
  
)

export default component.exports